import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'
import { toFilterOptions } from '@util/filter'

import { useStatusConfig } from '../../../status/hooks/useStatusConfig'
import { Page } from '../../../theme/components/Page'
import { PageSection } from '../../../theme/components/PageSection'
import { useHoofdleidingValuelists } from '../../../valuelists/hooks/useHoofdleidingValuelists'
import { useValuelists } from '../../../valuelists/hooks/useValuelists'
import { SubprocesFilters } from '../components/SubprocesFilters'
import { SubprocessenTableRow } from '../components/SubprocessenTableRow'
import { useSubprocessenSearch } from '../hooks/useSubprocessenSearch'

const headerCells = [
  { id: 'expired', numeric: false, label: '', fixed: 25 },
  { id: 'type', numeric: false, label: 'Type' },
  {
    id: 'dueDate',
    numeric: false,
    label: 'Opleverdatum',
    sort: true,
  },
  {
    id: 'created.date',
    numeric: false,
    label: 'Aangemaakt',
    sort: true,
  },
  {
    id: 'created.organisatie',
    numeric: false,
    label: 'Aangemaakt door',
    sort: true,
  },
  {
    id: 'assignedTo',
    numeric: false,
    label: 'Toegewezen aan',
    sort: true,
  },
  { id: 'entity', numeric: false, label: 'Horend bij', sort: true },
  { id: 'searchValues.gemeente', numeric: false, label: 'Gemeente' },
  { id: 'gebiedscode', numeric: false, label: 'Gebied & labels' },
  { id: 'actions', numeric: false, label: 'Details', fixed: 100 },
] as const

export const Subprocessen = () => {
  const { data: valuelists } = useValuelists()
  const { data: hoofdLeidingValuelists } = useHoofdleidingValuelists()
  const { data: statusConfig } = useStatusConfig()

  const {
    data: { items: subprocessen, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useSubprocessenSearch()

  return (
    <Page
      title={['Subprocessen', 'Hoofdleiding']}
      breadcrumbs={[
        { label: 'Hoofdleiding', href: '/home', tooltip: 'CAPO home' },
        { label: 'Subprocessen' },
      ]}
      fillScreen
    >
      <PageSection id="subprocessen" heading="Overzicht van uw subprocessen" />

      <Paper>
        <SubprocesFilters
          onChange={onChangeFilters}
          filters={filters}
          initialFilters={initialFilters}
          onReset={onReset}
          onRefresh={onRefresh}
          filterOptions={{
            ...valuelists,
            hoofdleiding: hoofdLeidingValuelists,
            labels: toFilterOptions(hoofdLeidingValuelists.labels),
            processtappen: statusConfig.processtappenHoofdleiding,
          }}
        />
        <StyledTable
          onChangeSort={onChangeSort}
          onChangePage={onChangePage}
          headerCells={headerCells}
          sort={sort}
          stats={{ count, skip, limit }}
          loading={isLoading}
          isError={isError}
        >
          {subprocessen.map((subproces) => {
            return (
              <SubprocessenTableRow key={subproces._id} subproces={subproces} />
            )
          })}
        </StyledTable>
      </Paper>
    </Page>
  )
}
